// Mock data for music producer portfolio

export const tracks = [
  {
    id: 1,
    title: "Bijli Si Tu",
    genre: "Electronic/EDM",
    duration: "3:30",
    bpm: 140,
    releaseDate: "To be released",
    coverArt: "/images/BST.png",
    audioUrl: "/audio/BST.mp3",
    description: "High-energy electronic track with electrifying synths and driving basslines"
  },
  {
    id: 2,
    title: "Baatein Adhuri",
    genre: "Trap",
    duration: "2:58",
    bpm: 81,
    releaseDate: "2025",
    coverArt: "/images/BAAD.jpg",
    audioUrl: "/audio/BAAD.mp3",
    description: "Moody trap production with deep 808s and atmospheric textures"
  },
  {
    id: 3,
    title: "Pyaar ka Naya Safar",
    genre: "Indie",
    duration: "4:00",
    bpm: 100,
    releaseDate: "2026",
    coverArt: "/images/PKNS.jpeg",
    audioUrl: "/audio/PKNS.mp3",
    description: "A heartfelt indie journey blending warm melodies and emotional lyricism"
  },
  {
    id: 4,
    title: "Diary",
    genre: "Indie",
    duration: "3:45",
    bpm: 120,
    releaseDate: "To be released",
    coverArt: "/images/Diary.jpeg",
    audioUrl: "/audio/Diary.mp3",
    description: "Intimate indie track with introspective storytelling and lush production"
  },
  {
    id: 5,
    title: "Drunken",
    genre: "Trap",
    duration: "3:10",
    bpm: 150,
    releaseDate: "2026",
    coverArt: "/images/Drunken.png",
    audioUrl: "/audio/Drunken.mp3",
    description: "A slow boom-bap trap banger with catchy melody and drums"
  },
  {
    id: 6,
    title: "Balam",
    genre: "Pop",
    duration: "3:20",
    bpm: 90,
    releaseDate: "2023",
    coverArt: "/images/Balam.jpeg",
    audioUrl: "/audio/Balam.mp3",
    description: "A pop banger to vive on"
  }
];

export const projects = [
  {
    id: 1,
    title: "Audio Visualizer Engine",
    category: "Creative Coding",
    description: "Real-time audio-reactive visualization system built with WebGL",
    thumbnail: "https://images.unsplash.com/photo-1558655146-d09347e92766?w=600&h=400&fit=crop",
    technologies: ["WebGL", "Web Audio API", "Three.js"],
    year: "2024"
  },
  {
    id: 2,
    title: "Beat Sequencer Interface",
    category: "Web App",
    description: "Interactive drum machine with custom sound design capabilities",
    thumbnail: "https://images.unsplash.com/photo-1598653222000-6b7b7a552625?w=600&h=400&fit=crop",
    technologies: ["React", "Tone.js", "Canvas API"],
    year: "2024"
  },
  {
    id: 3,
    title: "Synth Wave Experience",
    category: "Interactive Art",
    description: "Immersive 3D environment that responds to synthesizer input",
    thumbnail: "https://images.unsplash.com/photo-1617802690658-1173a812650d?w=600&h=400&fit=crop",
    technologies: ["Three.js", "MIDI", "GLSL Shaders"],
    year: "2023"
  },
  {
    id: 4,
    title: "Sound Portfolio Site",
    category: "Web Design",
    description: "Experimental portfolio showcasing audio-reactive design principles",
    thumbnail: "https://images.unsplash.com/photo-1550009158-9ebf69173e03?w=600&h=400&fit=crop",
    technologies: ["Next.js", "Framer Motion", "Web Audio"],
    year: "2023"
  }
];

export const aboutData = {
  name: "Archit",
  tagline: "Music Producer & Creative Developer",
  bio: "Blending cutting-edge sound design with innovative web experiences. Specializing in electronic music production and interactive audio-visual installations. Pushing the boundaries where music meets technology.",
  skills: [
    "Electronic Music Production",
    "Sound Design & Mixing",
    "Web Audio API",
    "3D Visualization",
    "Creative Coding",
    "UI/UX Development"
  ],
  stats: [
    { label: "Tracks Produced", value: "30+" },
    { label: "Years Experience", value: "3+" },
    { label: "Collaborations", value: "10+" }
  ]
};
